import { createContext } from 'react';

const addressContext = createContext();

export default addressContext;
